<template>
  <div :class="classes">
    <svg width="156" height="156" viewBox="0 0 156 156" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g :filter="`url(#${thisID})`">
        <path d="M98.7411 0H57.0538C25.5449 0 0 26.2597 0 58.6727V74.6373C0 75.6132 0.0233287 76.583 0.069986 77.5466C0.0243429 78.0305 0 78.5144 0 79.0195V147.409C0 156.018 5.12723 158.392 11.3925 152.686L36.8431 129.515C43.286 132.022 50.1405 133.303 57.0538 133.292H98.7411C130.25 133.292 155.795 107.05 155.795 74.6373V58.6727C155.795 26.2597 130.25 0 98.7411 0Z" :fill="fill"/>
      </g>
      <defs>
        <filter :id="thisID" x="0" y="-20" width="155.795" height="175.795" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="-20"/>
          <feGaussianBlur stdDeviation="15"/>
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
          <feColorMatrix type="matrix" :values="shadow"/>
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow"/>
        </filter>
      </defs>
    </svg>
    <div :class="$style.inner"><slot /></div>
  </div>
</template>
<script>
const COLORS = {
  pink: '#E8CEF4',
  yellow: '#FFFE92',
  orange: '#DDA38C',
  lightGrey: '#C4C4C4',
  grey: '#787878',
  teal: '#91B0B0',
  green: '#245847',
  brown: '#9F6A23',
  peach: '#DDA38C',
}

const SHADOWS = {
  pink: '0 0 0 0 0.873684 0 0 0 0 0.6 0 0 0 0 1 0 0 0 0.9 0',
  yellow: '0 0 0 0 0.8875 0 0 0 0 0.881393 0 0 0 0 0.221875 0 0 0 1 0',
  orange: '0 0 0 0 0.829167 0 0 0 0 0.495197 0 0 0 0 0.36276 0 0 0 1 0',
  lightGrey: '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0',
  grey: '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0',
  teal: '0 0 0 0 0.424861 0 0 0 0 0.554167 0 0 0 0 0.554167 0 0 0 1 0',
  green: '0 0 0 0 0.0940625 0 0 0 0 0.2625 0 0 0 0 0.207434 0 0 0 1 0',
  brown: '0 0 0 0 0.45 0 0 0 0 0.320171 0 0 0 0 0.14625 0 0 0 1 0',
  peach: '0 0 0 0 0.829167 0 0 0 0 0.495197 0 0 0 0 0.36276 0 0 0 1 0',
}

export default {
  name: 'Bubble',
  props: {
    // pink, yellow, orange, lightGrey, grey, teal, green, brown
    color: {
      type: String,
      default: '',
    },
    pin: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    animated: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      startAnimation: false,
      thisID: `filter-svg-${Math.round(Math.random() * 10000)}`,
    }
  },
  computed: {
    classes() {
      const {
        $style, pin, active, small, startAnimation,
      } = this

      return [
        $style.wrapper,
        startAnimation && $style.animation,
        pin && $style.withPin,
        active && $style.active,
        small && $style.small,
      ]
    },
    fill() {
      const { color } = this
      if (COLORS[color]) return COLORS[color]

      return COLORS.yellow
    },
    shadow() {
      const { color } = this
      if (SHADOWS[color]) return SHADOWS[color]

      return SHADOWS.color
    },
  },
  mounted() {
    if (this.animated) {
      setTimeout(() => { this.startAnimation = true }, Math.round(Math.random() * 4000))
    }
  },
}
</script>
<style lang="scss" module src="./Bubble.scss"></style>
